<template>
  <el-upload
    :action="action"
    :show-file-list="true"
    :data="ossData"
    :on-success="onSuccess"
    :on-error="onError"
    :on-exceed="onExceed"
    :on-remove="onRemove"
    :before-upload="beforeUpload"
    list-type="picture-card"
    :file-list="fileList"
    accept=".jpg,.png,.jpeg"
    :multiple="true"
    :limit="limit"
    :class="size"
  >
    <i slot="default" class="el-icon-plus"></i>
  </el-upload>
</template>

<script>
import { getOssSignData } from '@/service/getData'

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    limit: {
      type: Number,
      default: 9,
    },
    size: String,
  },
  data() {
    return {
      action: '',
      fileDir: '',
      ossData: {},
      fileList: [],
    }
  },
  watch: {
    value(val) {
      if (val.length == 0) {
        this.fileList = val
      }
    },
  },
  created() {
    this.fileList = this.value
    this.getOssData()
  },
  methods: {
    async getOssData() {
      let res = await getOssSignData()
      const data = res.data
      this.action = data.host
      this.fileDir = data.dir
      this.ossData = {
        key: data.dir,
        policy: data.policy,
        OSSAccessKeyId: data.access_key_id,
        success_action_status: '200',
        signature: data.signature,
      }
    },

    beforeUpload(file) {
      this.ossData.key += file.uid + '_' + file.name
    },

    onSuccess(response, file, fileList) {
      this.onFileChange(fileList)
    },

    onFileChange(fileList) {
      let fileArray = fileList.map((item) => {
        let url = item.url
        if (url.includes('blob')) {
          url = this.action + '/' + this.fileDir + item.uid + '_' + item.name
        }
        return { name: item.name, url: url }
      })
      this.$emit('input', fileArray)
    },

    onError(err, file, fileList) {
      console.log(err)
    },

    onExceed(files, fileList) {
      this.$message.error(`最多只能上传${this.limit}个文件`)
    },

    onRemove(file, fileList) {
      this.onFileChange(fileList)
    },
  },
}
</script>